export default "__VITE_ASSET__CsklGNyK__"